import { render, staticRenderFns } from "./ImportError.vue?vue&type=template&id=151f2722&scoped=true&"
import script from "./ImportError.vue?vue&type=script&lang=js&"
export * from "./ImportError.vue?vue&type=script&lang=js&"
import style0 from "./ImportError.vue?vue&type=style&index=0&id=151f2722&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151f2722",
  null
  
)

export default component.exports